import { render, staticRenderFns } from "./price2.vue?vue&type=template&id=73e507cc&scoped=true"
import script from "./price2.vue?vue&type=script&lang=js"
export * from "./price2.vue?vue&type=script&lang=js"
import style0 from "./price2.vue?vue&type=style&index=0&id=73e507cc&prod&lang=scss"
import style1 from "./price2.vue?vue&type=style&index=1&id=73e507cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e507cc",
  null
  
)

export default component.exports